
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {

	const blockProps = useBlockProps({
		className: 'c4l-procedural-context'
	});

	const {
		attributes,
		setAttributes
	} = props;

	const {
		content
	} = attributes;

	return (
		<div {...blockProps}>
			<RichText
				tagName='div'
				multiline='p'
				className='c4l-procedural-context-content'
				value={content}
				onChange={(newVal) => setAttributes({ content: newVal })}
				placeholder={__('Type the procedural context here', 'procedural-context')}
			/>
		</div>
	);
}
